import { useToast } from '@/hooks/use-toast';
import { handleApiError, authErrorHandler, networkErrorHandler, ErrorHandlerOptions } from '@/utils/error-handler';

// Custom hook for consistent error handling with toast notifications
export const useErrorHandler = () => {
    const { toast } = useToast();

    const handleError = (error: any, options: ErrorHandlerOptions = {}) => {
        const errorInfo = handleApiError(error, options);

        if (errorInfo.variant === 'destructive') {
            void import('@/lib/lark-error-capture')
                .then(({ beginSystemCapture }) =>
                    beginSystemCapture({
                        kind: 'api',
                        error,
                        toastTitle: errorInfo.title,
                        toastBody: errorInfo.message,
                        errorId: typeof error?.errorId === 'string' ? error.errorId : undefined,
                    }),
                )
                .catch(() => undefined);
        }

        if (options.showToast !== false) {
            toast({
                title: errorInfo.title,
                description: errorInfo.message,
                variant: errorInfo.variant,
            });
        }

        return errorInfo;
    };

    const handleAuthError = (error: any, customMessage?: string) => {
        const errorInfo = authErrorHandler(error, customMessage);

        toast({
            title: errorInfo.title,
            description: errorInfo.message,
            variant: errorInfo.variant,
        });

        return errorInfo;
    };

    const handleNetworkError = (error: any) => {
        const errorInfo = networkErrorHandler(error);

        toast({
            title: errorInfo.title,
            description: errorInfo.message,
            variant: errorInfo.variant,
        });

        return errorInfo;
    };

    return {
        handleError,
        handleAuthError,
        handleNetworkError,
    };
};
